
interface NavigationProps {
  isScrolled: boolean;
}

export function Navigation({ isScrolled }: NavigationProps) {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-white shadow-lg'
          : 'bg-white/10 backdrop-blur-sm'
      }`}
    >
      <div className="w-full px-8 py-4">
        <div className="flex items-center justify-between">
          <button onClick={scrollToTop} className="flex items-center gap-3 cursor-pointer">
            <img
              src="https://public.readdy.ai/ai/img_res/101d36f2-799a-4ab2-8f3a-5700b3b6e45d.png"
              alt="奄美薬剤師会ロゴ"
              className="h-12 w-auto"
            />
            <span
              className={`text-xl font-bold transition-colors ${
                isScrolled ? 'text-gray-900' : 'text-white'
              }`}
              style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
            >
              奄美薬剤師会
            </span>
          </button>

          <div className="hidden md:flex items-center gap-8">
            <button
              onClick={scrollToTop}
              className={`text-base font-medium transition-all cursor-pointer relative group ${
                isScrolled ? 'text-gray-700 hover:text-teal-600' : 'text-white hover:text-teal-400'
              }`}
            >
              ホーム
              <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-teal-500 transition-all duration-300 group-hover:w-full"></span>
            </button>
            <button
              onClick={() => scrollToSection('about')}
              className={`text-base font-medium transition-all cursor-pointer relative group ${
                isScrolled ? 'text-gray-700 hover:text-teal-600' : 'text-white hover:text-teal-400'
              }`}
            >
              協会について
              <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-teal-500 transition-all duration-300 group-hover:w-full"></span>
            </button>
            <button
              onClick={() => scrollToSection('services')}
              className={`text-base font-medium transition-all cursor-pointer relative group ${
                isScrolled ? 'text-gray-700 hover:text-teal-600' : 'text-white hover:text-teal-400'
              }`}
            >
              サービス
              <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-teal-500 transition-all duration-300 group-hover:w-full"></span>
            </button>
            <button
              onClick={() => scrollToSection('calendar')}
              className={`text-base font-medium transition-all cursor-pointer relative group ${
                isScrolled ? 'text-gray-700 hover:text-teal-600' : 'text-white hover:text-teal-400'
              }`}
            >
              カレンダー
              <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-teal-500 transition-all duration-300 group-hover:w-full"></span>
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className={`text-base font-medium transition-all cursor-pointer relative group ${
                isScrolled ? 'text-gray-700 hover:text-teal-600' : 'text-white hover:text-teal-400'
              }`}
            >
              お問い合わせ
              <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-teal-500 transition-all duration-300 group-hover:w-full"></span>
            </button>
          </div>

          <button
            className={`px-6 py-2.5 rounded-lg font-medium text-sm transition-all whitespace-nowrap cursor-pointer ${
              isScrolled
                ? 'border-2 border-amber-500 text-amber-600 hover:bg-amber-500 hover:text-white'
                : 'border-2 border-amber-500 text-white hover:bg-amber-500'
            }`}
          >
            会員ログイン
          </button>
        </div>
      </div>
    </nav>
  );
}
